import DashboardPage from '@/features/dashboard/DashboardPage'
import { createFileRoute } from '@tanstack/react-router'
import { t } from 'i18next'

export const Route = createFileRoute('/_protected/dashboard')({
    component: DashboardPage,
    head: () => ({
        meta: [{ title: t('dashboard') }],
    }),
})
